import { Injectable } from '@angular/core';
import {RegistrationService} from '../../registration.service';
import {RegistrationStorageService} from '../../../../../shared/services/registration-storage.service';
import {InsurerRegistrationData} from '../../../../models/registration-offer-data/insurer-registration-data.model';
import {PeselService} from '../../../../../shared/services/pesel.service';

@Injectable({
  providedIn: 'root'
})
export class SeparateInsurerDataService {

  get insurerRegistrationData(): InsurerRegistrationData {
    return this.registration.insurerData;
  }

  constructor(private registration: RegistrationService,
              private registrationStorage: RegistrationStorageService) { }

  changeFirstName(value: string): void {
    this.insurerRegistrationData.firstName = value;
    this.registrationStorage.updateRegistration();
  }

  changeLastName(value: string): void {
    this.insurerRegistrationData.lastName = value;
    this.registrationStorage.updateRegistration();
  }

  changePesel(value: string): void {
    this.insurerRegistrationData.pesel = value;
    this.insurerRegistrationData.birthDate = PeselService.getBirthdate(value);
    this.registrationStorage.updateRegistration();
  }

  changePostalCode(value: string): void {
    this.insurerRegistrationData.address.postalCode = value;
    this.registrationStorage.updateRegistration();
  }

  changeCity(value: string): void {
    this.insurerRegistrationData.address.city = value;
    this.registrationStorage.updateRegistration();
  }

  changeStreet(value: string): void {
    this.insurerRegistrationData.address.street = value;
    this.registrationStorage.updateRegistration();
  }

  changeBuildingNumber(value: string): void {
    this.insurerRegistrationData.address.buildingNumber = value;
    this.registrationStorage.updateRegistration();
  }

  changeFlatNumber(value: string): void {
    this.insurerRegistrationData.address.flatNumber = value;
    this.registrationStorage.updateRegistration();
  }
}
